export default __webpack_public_path__ + "static/media/drop.2842d939.png";